module.exports = __webpack_public_path__ + "static/TT1332_TW-MARK-M13-clean-dad038952dce861532d37d839271b1ca.png";